<template>
	<div class="badge badge-pill badge-secondary"
	     :title="text"
	     v-if="item.splitType !== 'default'">
		{{text}}
	</div>
</template>

<script>
	export default {
		props: {
			item: Object
		},
		computed: {
			text() {
				return this.$formatMessage('split_type_label', {
					type: this.item.splitType,
					totalUnits: this.item.splitTotalUnits,
					bookerName: this.item.splitBookerName
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/ui/expense-split-badge.vue